import $http from "../../axios";
import { Notification } from "element-ui";


export async function fetchAccountComparsion({ state, commit }) {
    await $http
        .get("/api/comparativo-cuentas", { params : state.params})
        .then(response => {
            commit("setAccountComparsion", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}


// WEBPACK FOOTER //
// ./src/modules/account-comparison/actions.js